import { Component, OnInit, Input } from '@angular/core';
import {  Banner } from '../../interface/grandround/datalist';
import { Router, ActivatedRoute } from '@angular/router';

/**
 * service import
 */
import { AuthService } from '../../auth/auth.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { EventMsgService } from '../../dataservices/master-service/event-msg.service';
import { ImageGroupService } from '../../dataservices/master-service/image-group.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import {NewLanguageService} from '../../dataservices/new-language/new-language.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { PostApiService } from '../../dataservices/post-api.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';

/**
 * RxJS imports
 */
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

/**
 * constant import
 */
import { NUMBERS, BANNER_IDENTIFIERS } from '../../constants/app.constants';
import {EVENT_NAME} from './../../analytics-event/analytics.constant';

/**
 * Interface import.
 */
import { AnalyticsInterface } from './../../analytics-event/analytics.model';

@Component({
  selector: 'app-banner-card',
  templateUrl: './banner-card.component.html',
  styleUrls: ['./banner-card.component.scss']
})
export class BannerCardComponent implements OnInit {
@Input() callingfrom;
 @Input() feedObj;
 BannerObjData:Banner;
 loginUserCustomeId:string;
 isGetsampleModal = false;
 @Input() productType;

 screen_name: string;
/**
 * Banner event object.
 */
 public analyticsBannerData: AnalyticsInterface;

/**
 * @notifier$ defines a notifier subject stream to end data streaming
 */
 private notifier$ = new Subject();

  constructor(
    public masterService: MasterserviceService,
    private dss: DataStorageService,
    public igs: ImageGroupService,
    public ems: EventMsgService,
    private postService: PostApiService,
    private jwtService: JwtDecodeService,
    private route: ActivatedRoute, public funCollectionService: FunCollectionService, private router: Router, private authService: AuthService, public mls: NewLanguageService) {
    this.loginUserCustomeId = this.authService.getbyName('profile_obj');
    this.screen_name = this.route.snapshot.data['screen_name'];
  }

  ngOnInit(): void {
  this.BannerObjData = this.feedObj;

  /**
   * Analytics banner data.
   */
  if (this.callingfrom) {
    this.analyticsBannerData = {
      'event_name': EVENT_NAME.GR_BANNER_CLICK,
      'product_type': this.feedObj.product_type,
      'product_type_id': this.feedObj.product_type_id,
      'screen_name': this.callingfrom
    };
  }
}

bannerAction(): boolean {
  if (this.masterService.isOnline == false) {
  this.masterService.isConnectionModalShown.next('1');
  return false;
  }

  switch (this.BannerObjData['target_type']) {
        case 'share': {
          //  window.open(environment.webSiteUrl +'/refer-and-earn/referal');
          // this.router.navigateByUrl('/refer-and-earn/referal');
          this.funCollectionService.navigateToRefetal();
          break;
        }
        case 'pharma': {
          this.funCollectionService.redirectOnSection(this.BannerObjData['target_type'], this.BannerObjData.target_id);
          break;
        }
        case 'survey': {
              this.funCollectionService.navigateToSurvey(this.BannerObjData.target_url);
              break;
        }
        case 'referral': {
          //  window.open(environment.webSiteUrl +'/refer-and-earn/referal');
          // this.router.navigateByUrl('/refer-and-earn/referal');
          this.funCollectionService.navigateToRefetal();
          break;
        }
        case 'notification': {

        break;
        }
        case 'point': {
         // window.open(environment.webSiteUrl +'refer-and-earn/referal');
         // this.router.navigateByUrl('/refer-and-earn/referal');
         this.funCollectionService.navigateToRefetal();
         break;
        }
        case 'feed': {
          // this.router.navigateByUrl('web/detail/'+this.BannerObjData.target_id);
          // this.funCollectionService.navigateToFeedDetail(this.BannerObjData.target_id);
          if (this.funCollectionService.device_detail.is_desktop != true) {
            this.funCollectionService.navigateToFeedDetail(this.feedObj.feed_id);
           // this.feedDetailModal=true;
          } else if ( this.BannerObjData.target_id != 0  &&  this.BannerObjData.target_id != null ) {
            const x = {is_show: true, feed_id: this.BannerObjData.target_id, mediaIdx: 0};
            this.dss.showFeedDetailInModal.next(x);
          } else {
            this.funCollectionService.navigateToFeedDetail(this.BannerObjData.target_id);
          }
          break;
        }
        case 'user': {
          this.router.navigateByUrl('/web/profile/' + this.loginUserCustomeId + '/user');
          break;
        }
        case 'event': {
          this.funCollectionService.navigateToEventDetail(this.BannerObjData.target_id);
          break;
        }
        case 'link': {
          this.funCollectionService.navigateToLink(this.BannerObjData.target_url);
          break;
        }
        case BANNER_IDENTIFIERS.EXTERNAL_LINK: {
          this.funCollectionService.navigateToLink(this.BannerObjData.target_url);
          break;
        }
        case 'journal': {
          this.funCollectionService.navigateToJournalDetail(this.BannerObjData.target_id);
          break;
        }
        case 'publication': {

        break;
        }
        case 'drugsample': {
          this.funCollectionService.redirectOnSection(this.BannerObjData['target_type'], this.BannerObjData.target_id);
          break;
        }
        case 'channel': {
          this.funCollectionService.navigateToChannelDetail(this.BannerObjData.target_id);
          break;
        }
        case 'invite': {
          // window.open(environment.webSiteUrl +'/refer-and-earn/referal');
         // this.router.navigateByUrl('/refer-and-earn/referal');
         this.funCollectionService.navigateToRefetal();
         break;
        }
        case 'chat': {

        break;
        }
        case 'profile': {
          this.router.navigateByUrl('/web/profile/' + this.loginUserCustomeId + '/user');
          break;
        }
        case 'profilesetup': {

        break;
        }
        case 'general': {

        break;
        }
        case 'cme': {
          this.funCollectionService.navigateToCmeDetail(this.BannerObjData.target_id);
          break;
        }
        case 'sponsored': {

        break;
        }
        case 'news': {
          this.funCollectionService.navigateToNews(this.BannerObjData.target_id);
          break;
          }
        case 'upgrade': {
          window.open(this.BannerObjData.target_url, '_blank');
          break;
        }

        case 'webinar': {
          const id = (this.BannerObjData.target_id == 0) ? '' : this.BannerObjData.target_id.toString();
          this.funCollectionService.navigateToWebinarDetail(id);
          break;
        }
        case 'doctalk': {
          this.funCollectionService.redirectOnSection('doctalk', this.BannerObjData.target_id);
          break;
        }
        case 'event_v3': {
          this.funCollectionService.navigateToNewEventDetail(this.BannerObjData.target_id);
          break;
        }
        case 'session_v3': {
          this.funCollectionService.navigateToNewSessionDetail(this.BannerObjData.target_id);
          break;
        }
        case 'vault': {
          this.funCollectionService.navigateToVault();
          break;
        }
        case 'invite_code_redirection': {
          this.funCollectionService.navigateToInviteCode(this.loginUserCustomeId);
          break;
        }
        case 'redirection_drug_chatbot': {
          this.funCollectionService.navigateToProductChatBot(this.BannerObjData.target_id);
          break;
        }
        case BANNER_IDENTIFIERS.GAME_DETAIL: {
          this.funCollectionService.navigateToGameDetail(this.BannerObjData['target_id']);
          break;
        }
        case BANNER_IDENTIFIERS.NCP_DETAIL : {
          this.funCollectionService.navigateToNCPDetail(this.BannerObjData['target_id']);
          break;
        }
        case BANNER_IDENTIFIERS.NCP_SUBTYPE : {
          this.updatePlayCount();
          break;
        }
        case BANNER_IDENTIFIERS.COMMUNITY_LIST : {
          this.funCollectionService.redirectOnSection(BANNER_IDENTIFIERS.COMMUNITY_LIST , this.BannerObjData['target_id']);
          break;
        }
        case BANNER_IDENTIFIERS.COMMUNITY_CREATE : {
          this.funCollectionService.redirectOnSection(BANNER_IDENTIFIERS.COMMUNITY_CREATE , this.BannerObjData['target_id']);
          break;
        }
        default:
          break;
      }
  } // news/list/57

  showGetsamplePopup(): void {
    this.isGetsampleModal = true;
  }

  resetProductGetsampleModal(): void {
    this.isGetsampleModal = false;
  }

 /**
  * Method for updating the count
  */
  updatePlayCount(): void {
    this.postService.updatePlayCount(this.BannerObjData['target_id']).
      pipe(takeUntil(this.notifier$)).
      subscribe(response => {
        this.jwtService.decodeData(response).then(data => {
          if (data['status'] === NUMBERS.ONE) {
            this.funCollectionService.navigateToGameScreen(this.BannerObjData['target_id']);
          }
        }, error => {
          console.log(error);
        });
      });
  }
}
